<div class="settings-menu-container">
  <div class="settings-menu-content">
    <!-- Settings Menu Items -->
    <div class="menu-items">
      <!-- Export KaspaCom Wallet -->
      <div class="menu-item" (click)="onExportWallet()">
        <div class="menu-item-icon">
          <kc-icon
            iconClass="icon-download"
            size="md"
            color="var(--text-primary)"
          />
        </div>
        <div class="menu-item-content">
          <div class="menu-item-title">Export KaspaCom wallet</div>
          <div class="menu-item-subtitle">Backup your wallet seed phrase</div>
        </div>
        <div class="menu-item-arrow">
          <kc-icon
            iconClass="icon-chevron-right"
            size="sm"
            color="var(--text-secondary)"
          />
        </div>
      </div>

      <!-- Delete Wallet -->
      <div class="menu-item delete-wallet-item" (click)="onDeleteWallet()">
        <div class="menu-item-content">
          <div class="menu-item-title delete-wallet-title">Delete wallet</div>
          <div class="menu-item-subtitle">Permanently remove your wallet</div>
        </div>
        <div class="menu-item-arrow">
          <kc-icon
            iconClass="icon-chevron-right"
            size="sm"
            color="var(--text-secondary)"
          />
        </div>
      </div>
    </div>

    <!-- Logout Button -->
    <div class="logout-section">
      <kc-button
        [text]="'Log out'"
        variant="secondary"
        size="m"
        [isFullWidth]="true"
        (buttonClick)="onLogout()"
        class="logout-button"
      />
    </div>
  </div>
</div>
